<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="toc" id="_idContainer002" role="doc-toc">
<p class="TOCtitle">Table of Contents</p>
<p class="TOCitem"><a href="#/The_Texans_Inherited_Family#_idTextAnchor001">The Texan’s Inherited Family</a> by Noelle Marchand</p>
<p class="TOCitem"><span href="#/A_Home_for_His_Family#_idTextAnchor022" title="Link target outside of Sample">A Home for His Family</span> by Jan Drexler</p>
<p class="TOCitem">Excerpt from <span href="#/Excerptone" title="Link target outside of Sample">Caring for Her Amish Family</span> by Carrie Lighte</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Table_of_Contents.vue?63ba336f